export default __webpack_public_path__ + "static/media/icon.14242afb.svg";